<template>
    <b-card v-if="service != null" @click="$emit('productSelect', service.productid)" :style="'height: max-content'" :body-class="'rounded' + (isActive ? ' outline-' + service.class : '') + (selectedProduct != null && selectedProduct.productid === service.productid ? ' adjustForSelected' : '')" :class="service.class + (selectedProduct != null && selectedProduct.productid === service.productid ? ' selectedOutline' : ' hover-' + service.class)">
        <b-card-header :class="service.class + '-header m-4'">{{ service.name }}</b-card-header>
        <slot name='description'>
            <b-card-text class="m-4">
              {{ service.description }}
              <br />
              {{ service.devices }} devices
              <br />
              Upload {{ service.upDescription }}
              <br />
              Download {{ service.downDescription }}
            </b-card-text>
        </slot>
        <slot name='action'>
        </slot>
        
        <b-card-footer v-if="(active || canUpgrade || canDowngrade)" :class="'p-3 product-footer-' + service.class + ' ' + (active ? 'active-product-footer' : '')">
            <span v-if="active">
            <div style="text-align: center;">YOUR CURRENT FLEXIPLAN</div>
            <div style="text-align: center;">Renewal: {{ activeuntil.toDateString() }}</div>
            <div style="text-align: center;">Daily Cost: {{ service.credits }} FlexiCredit</div>
            </span>
            <span v-if="canUpgrade" >
            <div style="text-align: center;">UPGRADE</div>
            <div style="text-align: center;">Boost until: {{ activeuntil.toDateString() }}</div>
            <div style="text-align: center;">{{ upgradeCreditCost(service, activeproduct, entitlements) > 1 ? 'for '+upgradeCreditCost(service, activeproduct, entitlements)+' credits' : upgradeCreditCost(service, activeproduct, entitlements) === 0 ? 'at no extra cost' : 'for '+upgradeCreditCost(service, activeproduct, entitlements)+' credit' }}</div>
            </span>
            <span v-if="canDowngrade" >
            <div style="text-align: center;">DOWNGRADE</div>
            <div style="text-align: center;">Downgrade start: {{ activeuntil.toDateString() }}</div>
            <div style="text-align: center;">Daily Cost: {{ service.credits }} FlexiCredit</div>
            </span>
        </b-card-footer>
        <b-card-footer v-else></b-card-footer>
    </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdjustFlexiCard',
  props: {
    service: {
        type: Object, // name, descripion, class
        required: true
    },
    isActive: {
        type: Boolean,
        default: false
    },
    activeuntil: {
        type: Date,    
    },
    canUpgrade: {
        type: Boolean,
        default: false
    },
    canDowngrade:{
        type: Boolean,
        default: false
    },
    selectedProduct: {
        type: Object,
        default: null
    },
    entitlements: {
        type: Array,
        required: true
    }
  },
  data() {
    return {
      active: this.isActive,
    }
  },
  computed: {
    ...mapGetters({
      allPrices: "pricing/getPrices",
      activeproduct: "plan/getActiveProduct"
    })
  },
  watch: {
    isActive: function() {
      this.$nextTick(() => { this.active = this.isActive})
    }
  },
  methods: {
    upgradeCreditCost(service, activeproduct, entitlements) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);  // normalize to the start of the day
        
        let total = 0;

        for (let e of entitlements) {
            let differenceInDays = Math.floor((new Date(e.dateto) - today) / (1000 * 60 * 60 * 24));
            if (entitlements.indexOf(e) === entitlements.length - 1) {
              differenceInDays += 1;
            }
            if (!isNaN(differenceInDays)) {
                total += (differenceInDays * (service.credits - activeproduct.credits));
            }
        }

        return total > 0 ? total : 0;
    }
  }

}
</script>

<style lang="scss" scoped>

.svc1 {
  background: linear-gradient(to right, #373b44, #38AADE) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 1px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc2 {
  background: linear-gradient(to right, #a1540b, #EE811A) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px !important;
  height: 100%;
  margin: 12px;
  padding: 1px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc3 {
  background: linear-gradient(to right, #517043, #5DB12F) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 1px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc4 {
  background: linear-gradient(to right, #a08b00 5%, mix(#a08b00, #cdb970, 50%) 20%, #cdb970 40%) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 1px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}

.svc1-header {
  border: solid white 2px;
  background: linear-gradient(to left, #526797, #3f66ad) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc2-header {
  border: solid white 2px;
  background: linear-gradient(to left, #a75a12, #EE811A) !important;
  border-radius: 14px 14px 14px 14px;
  box-shadow: 12px 10px 8px #373b44;
}

.svc3-header {
  border: solid white 2px;
  background: linear-gradient(to left, #79a560, #5DB12F) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc4-header {
  border: solid white 2px;
  background: linear-gradient(to left, #867a50, #ccba78) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.card-body {
  padding: 0 0 0 0 !important;
  border-radius: 20px 20px 20px 20px !important;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
}

.product-footer-svc1 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  -moz-border-radius-topright: 140px 60px !important;
  -webkit-border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  -moz-border-radius-topleft: 140px 60px !important;
  -webkit-border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  -moz-border-radius-bottomleft: 20px !important;
  -webkit-border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  -moz-border-radius-bottomright: 20px !important;
  -webkit-border-bottom-right-radius: 20px !important;
  background: #4972c0;
  border: 1px black solid;
}

.product-footer-svc2 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #EE811A;
  border: 1px black solid;
}

.product-footer-svc3 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #4f9e25;
  border: 1px black solid;
}

.product-footer-svc4 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #ccba78;
  border: 1px black solid;
}


.active-product-footer {
  border: solid #551355 4px;
  margin: -4px -1px;
}

.selectedOutline {
  border: yellowgreen 8px solid;
}

.adjustForSelected {
  margin: -7px;
}

.hover-svc1:hover {
  box-shadow: 0 0 20px 10px #4972c0;
}

.hover-svc2:hover {
  box-shadow: 0 0 20px 10px #EE811A;
}

.hover-svc3:hover {
  box-shadow: 0 0 20px 10px #4f9e25;
}

.hover-svc4:hover {
  box-shadow: 0 0 20px 10px #ccba78;
}

.pad-outline {
  margin: 0 8px;
}
</style>